export default {
  setSearchText (state: {[key:string]: string}, payload: string) {
    state.searchText = payload
  },
  setOrderName (state: {[key:string]: string}, name: string) {
    state.orderName = name
  },
  setFieldType (state: {[key:string]: number}, type: number) {
    state.fieldType = type
  },
  setVarietyId (state: {[key:string]: number}, id: number) {
    state.varietyId = id
  },
  setGradeId (state: {[key:string]: number}, id: number) {
    state.gradeId = id
  },
  setStageId (state: {[key:string]: number}, id: number) {
    state.stageId = id
  },
  setRiskId (state: {[key:string]: number}, id: number) {
    state.riskId = id
  },
  setChoiceField (state: {[key:string]: number}, id: number) {
    state.choiceFieldId = id
  },
  setBeforeRecordDate (state: {[key:string]: number}, date: number) {
    state.beforeRecordDate = date
  }
}
